import template from './custom-sort-tour.html';
import { GoTour, GoTourService, goTourServiceToken } from 'go-modules/go-tour/go-tour.service';
import dayjs from 'dayjs';
import { Inject, Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { PlacementEngine, placementEngineToken } from 'go-modules/go-tour/placement-engine.factory';

@Injectable({
	providedIn: 'root'
})
export class CustomSortTourService {
	public readonly startDate = dayjs('2024-02-21 17:00:00').toDate();
	public readonly title = 'custom-sort-tour_title' as const;
	public readonly viewTrackKey = 'custom-sort-tour' as const;
	public readonly selector = '.reorder-btn' as const;
	private tour: GoTour;

	public constructor (
		@Inject(goTourServiceToken) private goTour: GoTourService,
		private translateFilter: TranslateService,
		@Inject(placementEngineToken) private placementEngine: PlacementEngine
	) {}

	public getTour (): GoTour {
		const placement = this.placementEngine.POSITION.LEFT;
		const title = this.translateFilter.instant(this.title);
		if (!this.tour) {
			this.tour = this.goTour.defineTour({
				viewTrackKey: this.viewTrackKey,
				constraints: {
					isOnboarding: false,
					tourStartDate: this.startDate
				},
				tourStepClass: this.viewTrackKey,
				steps: [
					{
						tourTitleAriaLabel: title,
						title,
						template,
						selector: this.selector,
						placement
					}
				]
			});
		}

		return this.tour;
	}
}
